import * as ApplicationIcons from '../../components/ApplicationIcons';
import { EmbedIcon } from '../../components/Icons';
import EmbeddableTypes from '../../types/EmbeddableTypes';
export function getEmbedInformationsList() {
  return [{
    id: EmbeddableTypes.AIRTABLE,
    title: 'Airtable',
    description: 'Insert an Airtable base or table',
    placeholder: 'Paste an Airtable base link or table link',
    iconActive: ApplicationIcons.AirtableIcon,
    iconGrey: ApplicationIcons.AirtableGreyIcon
  }, {
    id: EmbeddableTypes.ASANA,
    title: 'Asana',
    promoted: true,
    description: 'Insert an Asana Task',
    placeholder: 'Paste an Asana task link',
    iconActive: ApplicationIcons.AsanaIcon,
    iconGrey: ApplicationIcons.AsanaGreyIcon
  }, // {
  //   id: EmbeddableTypes.CLICKUP,
  //   title: 'ClickUp',
  //   description: 'Insert a ClickUp task',
  //   placeholder: 'Paste a ClickUp task link',
  //   iconActive: ApplicationIcons.ClickUpIcon,
  //   iconGrey: ApplicationIcons.ClickUpGreyIcon,
  // },
  {
    id: EmbeddableTypes.DEFAULT,
    title: 'Embed',
    description: 'Insert an embed',
    placeholder: 'Paste a URL or type it',
    iconActive: EmbedIcon,
    iconGrey: EmbedIcon
  }, {
    id: EmbeddableTypes.DRAWIO,
    title: 'Draw.io',
    description: 'Insert a drawing',
    placeholder: 'Paste a URL or type it',
    iconActive: ApplicationIcons.DrawIOIcon,
    iconGrey: ApplicationIcons.DrawIOIcon
  }, {
    id: EmbeddableTypes.FIGMA,
    title: 'Figma',
    description: 'Insert a Figma frame or file',
    placeholder: 'Paste a Figma file link',
    iconActive: ApplicationIcons.FigmaIcon,
    iconGrey: ApplicationIcons.FigmaGreyIcon
  }, {
    id: EmbeddableTypes.GITHUB,
    title: 'GitHub',
    promoted: true,
    description: 'Insert a Github gist or issue',
    placeholder: 'Paste a GitHub gist link or issue link',
    iconActive: ApplicationIcons.GitHubIcon,
    iconGrey: ApplicationIcons.GitHubGreyIcon
  }, {
    id: EmbeddableTypes.GOOGLE_DRIVE,
    title: 'Google Drive',
    description: 'Insert a Google doc, sheet, file',
    placeholder: 'Paste a Google Drive public link',
    iconActive: ApplicationIcons.GoogleDriveIcon,
    iconGrey: ApplicationIcons.GoogleDriveGreyIcon
  }, {
    id: EmbeddableTypes.GOOGLE_MAPS,
    title: 'Google Maps',
    promoted: true,
    description: 'Insert a Google Maps',
    placeholder: 'Paste a Google Maps link',
    iconActive: ApplicationIcons.GoogleMapsIcon,
    iconGrey: ApplicationIcons.GoogleMapsGreyIcon
  }, {
    id: EmbeddableTypes.INVISION,
    title: 'InVision',
    description: 'Insert an Invision project  ',
    placeholder: 'Paste an InVision project link',
    iconActive: ApplicationIcons.InVisionIcon,
    iconGrey: ApplicationIcons.InVisionGreyIcon
  }, {
    id: EmbeddableTypes.TRELLO,
    title: 'Trello',
    promoted: true,
    description: 'Insert a Trello card',
    placeholder: 'Paste a Trello card link',
    iconActive: ApplicationIcons.TrelloIcon,
    iconGrey: ApplicationIcons.TrelloGreyIcon
  }, {
    id: EmbeddableTypes.TWITTER,
    title: 'Twitter',
    promoted: true,
    description: 'Insert a Tweet',
    placeholder: 'Paste a Tweet link',
    iconActive: ApplicationIcons.TwitterIcon,
    iconGrey: ApplicationIcons.TwitterGreyIcon
  }, {
    id: EmbeddableTypes.YOUTUBE,
    title: 'YouTube',
    promoted: true,
    description: 'Insert a YouTube video',
    placeholder: 'Paste a YouTube link',
    iconActive: ApplicationIcons.YouTubeIcon,
    iconGrey: ApplicationIcons.YouTubeGreyIcon
  }];
}
export function getEmbedInformation(type) {
  return getEmbedInformationsList().find(function (_ref) {
    var id = _ref.id;
    return id === type;
  });
}